import {
    DashboardCustomize,
    ListAlt,
    FlipToBackOutlined,
    AccountCircle,
    MiscellaneousServices,
    Groups,
} from "@mui/icons-material";
import inventoryIcon from "../../images/inventory.svg";
import settingsIcon from "../../images/settings.svg";
import reportsIcon from "../../images/report-icon.svg";
import tagsIcon from "../../images/tags.svg";
import variationsIcon from "../../images/variations.svg";
import deliveryIcon from "../../images/deliveryIcon.svg";
import EvoucherImg from "../../images/evoucher.svg";

// Declarative, section-grouped admin sidebar config.
// `flag` (when present) refers to a boolean key on `state.configs`;
// the item only renders when that flag is truthy. Items without a
// `flag` always render.
const navConfig = [
    {
        section: "Dashboard",
        items: [
            { label: "Dashboard", path: "/zed_ecommerce/dashboard", icon: DashboardCustomize, iconType: "mui" },
        ],
    },
    {
        section: "Catalog",
        items: [
            { label: "Categories", path: "/zed_ecommerce/categories", icon: inventoryIcon, iconType: "img" },
            { label: "Products", path: "/zed_ecommerce/products", icon: inventoryIcon, iconType: "img" },
            { label: "Variations", path: "/zed_ecommerce/variations", icon: variationsIcon, iconType: "img" },
            { label: "Tags", path: "/zed_ecommerce/tags", icon: tagsIcon, iconType: "img" },
            { label: "Pre-Orders", path: "/zed_ecommerce/preOrders", icon: FlipToBackOutlined, iconType: "mui" },
            { label: "Additional Services", path: "/zed_ecommerce/additionalServices", icon: MiscellaneousServices, iconType: "mui", flag: "additionalServicesEnabled" },
            { label: "Packaging Fees", path: "/zed_ecommerce/packaging", icon: MiscellaneousServices, iconType: "mui", flag: "packageFeeEnabled" },
        ],
    },
    {
        section: "Sales",
        items: [
            { label: "Orders", path: "/zed_ecommerce/orders", icon: ListAlt, iconType: "mui" },
            { label: "Campaigns", path: "/zed_ecommerce/evouchercompaings", icon: EvoucherImg, iconType: "img", flag: "evoucherEnabled" },
            { label: "Purchased", path: "/zed_ecommerce/evoucherpurchased", icon: EvoucherImg, iconType: "img", flag: "evoucherEnabled" },
        ],
    },
    {
        section: "Customers",
        items: [
            { label: "Customers", path: "/zed_ecommerce/customers", icon: AccountCircle, iconType: "mui" },
        ],
    },
    {
        section: "Marketing",
        items: [
            { label: "Featured Teams", path: "/zed_ecommerce/featuredTeams", icon: Groups, iconType: "mui", flag: "featuredTeamsEnabled" },
        ],
    },
    {
        section: "Reports",
        items: [
            { label: "Reports", path: "/zed_ecommerce/reports", icon: reportsIcon, iconType: "img" },
        ],
    },
    {
        section: "Configuration",
        items: [
            { label: "Shipping Regions", path: "/zed_ecommerce/shippingRegions", icon: deliveryIcon, iconType: "img" },
            { label: "Pick ups", path: "/zed_ecommerce/pickups", icon: deliveryIcon, iconType: "img" },
            { label: "E-commerce", path: "/zed_ecommerce/configurations", icon: settingsIcon, iconType: "img" },
            { label: "Store Appearance", path: "/zed_ecommerce/customizeStore", icon: settingsIcon, iconType: "img", flag: "ecommerceUrlEnabled" },
        ],
    },
];

export default navConfig;
